import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { RefreshCw } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import MissoesHoje from './MissoesHoje';
import { qtdAtividade } from './rotina';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const fmtLocal = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

// As missões do dia dentro da janela do botão "Minhas demandas" / "Rodízio" (Adnéia,
// 17/10/2026: "vamos tirar as missões do Dashboard; aparece a atividade de cada um quando
// apertar o botão rodízio, e só da pessoa; o meu aparece os 3"). Busca tudo quando a
// janela abre. somente = nome de quem vê (atendente); vazio = os três (gestão, com metas).
const MissoesRodizio = ({ somente = null }) => {
  const { getAuthHeader } = useAuth();
  const [dados, setDados] = useState(null);
  const [metas, setMetas] = useState([]);
  const [erro, setErro] = useState('');

  useEffect(() => {
    let vivo = true;
    const h = { headers: getAuthHeader() };
    const hoje = new Date();
    const ini = new Date(hoje); ini.setDate(ini.getDate() - 3);
    const fim = new Date(hoje); fim.setDate(fim.getDate() + 7);
    Promise.all([
      axios.get(`${API_URL}/api/dashboard/verificacao-status`, h),
      axios.get(`${API_URL}/api/dashboard/verificacao-atividades`, h),
      axios.get(`${API_URL}/api/rodizio/escala`, { ...h, params: { inicio: fmtLocal(ini), fim: fmtLocal(fim) } }),
      axios.get(`${API_URL}/api/dashboard/acessos`, h).catch(() => null),
      axios.get(`${API_URL}/api/retirada`, h).catch(() => null),
      axios.get(`${API_URL}/api/pagamento`, h).catch(() => null),
      axios.get(`${API_URL}/api/cancelamentos?limit=2000&slim=1`, h).catch(() => null),
    ]).then(([vs, va, esc, ac, ret, pag, canc]) => {
      if (!vivo) return;
      const listas = { retirada: ret?.data || [], pagamento: pag?.data?.pedidos || [], cancelamentos: canc?.data?.cancelamentos || [] };
      setDados({
        verifRows: vs.data.rows || [],
        ativRows: (va.data.rows || []).map(a => ({ motivo: a.motivo, ultima: a.ultima, qtd: qtdAtividade(a, listas) })),
        escala: esc.data,
        portais: Object.fromEntries((ac?.data?.rows || []).filter(x => x.link).map(x => [x.canal, x.link])),
      });
    }).catch(() => { if (vivo) setErro('Não carregou as missões. Feche e abra de novo.'); });
    // As metas pesam mais: só para a gestão, e chegam depois dos cartões.
    if (!somente) {
      axios.get(`${API_URL}/api/dashboard/v2/visao-geral`, { ...h, params: { periodo_dias: 30 } })
        .then(r => { if (vivo) setMetas(r.data?.metas || []); }).catch(() => {});
    }
    return () => { vivo = false; };
  }, [getAuthHeader, somente]);

  if (erro) return <p className="text-sm text-red-600">{erro}</p>;
  if (!dados) return <p className="text-sm text-muted-foreground flex items-center gap-2"><RefreshCw className="h-4 w-4 animate-spin" /> Montando as missões…</p>;

  const esc = dados.escala || {};
  const ref = (esc.dias || []).find(d => d.data === esc.hoje) || (esc.dias || []).find(d => d.data > esc.hoje);
  if (!ref) return <p className="text-sm text-muted-foreground">Sem rodízio previsto para os próximos dias.</p>;
  const donoDe = (item) => {
    if ((esc.finalizadores || []).includes(item)) return null;
    const lista = esc.lista_do_item?.[item];
    return (lista ? ref.dono_lista?.[lista] : esc.gestao) || null;
  };

  return (
    <div className="space-y-2">
      {ref.data !== esc.hoje && (
        <p className="text-xs text-muted-foreground">Hoje não tem rodízio: estas são as missões de {ref.data_br}.</p>
      )}
      <MissoesHoje
        embutido
        somente={somente}
        verifRows={dados.verifRows}
        ativRows={dados.ativRows}
        donoDe={donoDe}
        pessoas={[ref.dono_lista?.azul, ref.dono_lista?.laranja].filter(Boolean)}
        gestao={esc.gestao}
        dataRef={{ data: ref.data, data_br: ref.data_br, ehHoje: ref.data === esc.hoje }}
        portais={dados.portais}
        metas={metas}
      />
      <p className="text-xs text-muted-foreground">Bolinha verde: feito hoje (o ✓ da verificação no Dashboard). Vermelha: pendente.</p>
    </div>
  );
};

export default MissoesRodizio;
